import {Injectable, OnDestroy} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {Permission, User} from 'smag-commons/dto/api';
import {SmagApiService} from '../api/smag-api.service';
import {LoginService} from './login.service';

/**
 * Service that provides user management functionalities.
 */
@Injectable()
export class UsersService implements OnDestroy {

    private destroyed = new Subject<void>();
    private permissionsSubj: ReplaySubject<Permission[]>;

    constructor(private readonly apiService: SmagApiService,
                private readonly loginService: LoginService) {
        this.permissionsSubj = new ReplaySubject<Permission[]>(1); // like BehaviorSubject but with no need for initial value
        // reload is triggered every time a user gets logged-in (different principals may have different permissions)
        loginService.addSetupHook(1, profile => {
            // NOTE: hierarchy is actually not needed here, but we do not want to wait for completion
            // of network loading before setting up users
            console.debug(`Retrieving user permissions for user ${profile?.username}`);
            return this.reloadPermissions();
        });
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    loadUser(u3id: string): Observable<User> {
        return this.apiService.loadUser(u3id);
    }

    get permissions(): Observable<Permission[]> {
        return this.permissionsSubj.asObservable();
    }

    reloadPermissions(): Promise<Permission[]> {
        return this.apiService.getUserPermissions().toPromise()
            .then(perms => {
                this.permissionsSubj.next(perms.permissions);
                return perms.permissions;
            });
    }
}
